import { useContext, useEffect, useRef, useState } from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useUser } from "contexts/userContext/userContext.js";
import { UploaderContext } from "../UploaderComponent/HomeUploader.js";
import { useUploadingSpeed } from "./useUploadingSpeed.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const usePromoSubLogic = () => {
  const { isLoggedIn } = useUser();
  const { getDirection } = useContent();
  const { getUploading, getHideSubmit } = useUploader();
  const { filesProgress } = useContext(UploaderContext);

  const [showPromo, setShowPromo] = useState(false);
  const [templateIdToShow, setTemplateIdToShow] = useState(null);
  const [availableTemplatesIds, setAvailableTemplatesIds] = useState([]);

  const { estimationSeconds } = useUploadingSpeed(filesProgress);

  // handle promo
  const promoWasShown = useRef(false);
  const timeStart = useRef(null);

  const getShowPromo = async () => {
    const res = await apiRequest(
      "Notifications",
      "GetSubscribersFeaturesPromoNotifications"
    );
    if (res.status === "success") {
      const isRtl = getDirection() === "rtl";

      if (res.data) {
        // defaultArray - array of indexes to show in the promo based on available
        const availableTemplates = res.data.NotificationsIds;
        //keeping it to sate to filter hardcoded list of features
        setAvailableTemplatesIds(availableTemplates);
        // showedIndexes - array of indexes that already showed
        const showedTemplates = res.data.UserNotifications?.map(
          (item) => item.TemplateNotificationId
        );
        // filteredArray - array of indexes that not showed yet
        const filteredArray = availableTemplates.filter(
          (item) => !showedTemplates.includes(item)
        );

        if (filteredArray.length === 0) {
          setTemplateIdToShow(null);
        } else {
          setTemplateIdToShow(
            filteredArray[isRtl ? filteredArray.length - 1 : 0] ||
              availableTemplates[0]
          );
        }
      }
    } else {
      setTemplateIdToShow(null);
    }
  };

  useEffect(() => {
    if (getUploading()) {
      timeStart.current = new Date().getTime();
      if (isLoggedIn()) getShowPromo();
    }
  }, [getUploading(), isLoggedIn()]);

  useEffect(() => {
    // add here the condition from notification
    if (
      !promoWasShown.current &&
      getUploading() &&
      window.innerWidth > 1200 &&
      estimationSeconds > 60 &&
      new Date().getTime() - timeStart.current > 5000 &&
      getHideSubmit()
    ) {
      setShowPromo(true);
      promoWasShown.current = true;
    }
  }, [
    getUploading(),
    estimationSeconds,
    isLoggedIn(),
    templateIdToShow,
    getHideSubmit(),
  ]);

  return { showPromo, setShowPromo, templateIdToShow, availableTemplatesIds };
};

export default usePromoSubLogic;
